var map = {
	"./1.JPG": 23,
	"./10.JPG": 952,
	"./2.JPG": 121,
	"./3.JPG": 815,
	"./4.JPG": 294,
	"./5.JPG": 675,
	"./6.JPG": 579,
	"./7.JPG": 410,
	"./8.JPG": 483,
	"./9.JPG": 422
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 748;